import { createSlice } from "@reduxjs/toolkit";
import sendPayementLink from "../../../rtk-apis/subscription/sendPayementLink"

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const sendPayementLinkSlice = createSlice({
  name: "sendPayementLinkSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(sendPayementLink.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(sendPayementLink.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(sendPayementLink.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default sendPayementLinkSlice.reducer;
